import "./simpleBadge.css"
import React from "react"

export const SimpleBadge = ({ selected = true, status = "", text, title = "", onClick = () => { } }) => {
    return <div className={`${selected ? "selected" : ""} ${status} simpleBadge d-inline-block`} onClick={onClick}>
        <div style={{ marginRight: "10px" }}>
            {title !== "" ? <div><b>{title}</b></div> : <></>}
            {text}
        </div>
    </div>
}